// ============================================================
// RECURRENCE DISPLAY HELPERS
// ============================================================

export function formatRecurrencePattern(task) {
    console.log(
  task.name,
  task.recurrence_type_id,
  task.recurrence_types
)

  if (!task) return null

  // Daily
  if (task.recurrence_type_id === 1) {
    return 'Every Day'
  }

  // Weekly
  if (task.recurrence_type_id === 2) {

    if (
      task.days_of_week &&
      task.days_of_week.length > 0
    ) {

      const dayNames = [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
      ]

      return (
        'Every ' +
        task.days_of_week
          .map(day => dayNames[day])
          .join(' • ')
      )
    }

    return 'Every Week'
  }

  // Monthly
  if (task.recurrence_type_id === 3) {
    return 'Every Month'
  }

  // Yearly
  if (task.recurrence_type_id === 4) {
    return 'Every Year'
  }

  return null
}